export const loginForm = 'login-form';

export default {
  loginForm,
};
